import useUserPermissions from "@/common/hooks/useUserPermissions";
import { TabsTrigger } from "../../ui/tabs";
import { useId } from "react";
import { Tooltip } from "react-tooltip";
import { cn } from "@/common/utils/cn";

interface TabTriggerProps {
  value: string;
  label: string;
  className?: string;
  disabled?: boolean;
  operationKlassToCheckPermission?: string;
  propertiesToCheckPermission?: string[];
  tooltipMessage?: string;
  noPermissionText?: string;
}

const TabTrigger = ({
  value,
  label,
  className,
  disabled,
  operationKlassToCheckPermission,
  propertiesToCheckPermission,
  tooltipMessage,
  noPermissionText = 'Você não tem permissão',
}: TabTriggerProps) => {
  const { hasUserPermission, isUserPermissionsPending } = useUserPermissions();
  const tooltipId = useId();

  const isPermissionNeeded = !!operationKlassToCheckPermission;
  const hasPermission = isPermissionNeeded && hasUserPermission(operationKlassToCheckPermission, propertiesToCheckPermission);

  return (
    <>
      <TabsTrigger
        value={value}
        className={cn(className, 'disabled:pointer-events-auto')}
        disabled={disabled || (isPermissionNeeded && !hasPermission)}
        data-testid={`tab_${value}`}
        data-tooltip-id={((isPermissionNeeded && !hasPermission) || tooltipMessage) ? tooltipId : ''}
      >
        {label}
      </TabsTrigger>

      {((isPermissionNeeded && !hasPermission && !isUserPermissionsPending) || tooltipMessage) && (
        <Tooltip
          id={tooltipId}
          place="bottom"
          className="z-50"
        >
          {tooltipMessage || noPermissionText}
        </Tooltip>
      )}
    </>
  );
}

export default TabTrigger;
